// extracted by mini-css-extract-plugin
export default {"row":"ViewUserData_row__wPcJ+"};